import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["data-kt-sticky"]
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div id=\"kt_page_title\" data-kt-swapper=\"true\" data-kt-swapper-mode=\"prepend\" data-kt-swapper-parent=\"{default: &#39;#kt_content_container&#39;, lg: &#39;#kt_header_container&#39;}\" class=\"page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-lg-2 pb-2 pb-lg-0\"><h3 class=\"logo-title fs-2\"><div><span class=\"text-dark-blue\">Inclusion</span><span class=\"text-red\">Impact</span></div><div class=\"ms-20 ps-12\"><span class=\"text-red\">Index</span><span class=\"text-custom-blue\">Plus</span></div></h3></div>", 1)
const _hoisted_3 = { class: "d-flex d-lg-none align-items-center me-2" }
const _hoisted_4 = {
  class: "btn btn-icon btn-active-icon-primary",
  id: "kt_aside_toggle"
}
const _hoisted_5 = { class: "svg-icon svg-icon-2x" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex ms-3"
}
const _hoisted_7 = {
  id: "button-year-switcher",
  type: "button",
  class: "btn btn-flex flex-center btn-bg-white btn-text-gray-500 btn-active-color-primary w-md-auto px-md-20",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_8 = {
  id: "span-current-year",
  class: "d-md-inline",
  style: {"color":"#181C32","font-weight":"400"}
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-chevron-down h-2px",
  style: {"position":"relative","top":"2px","left":"70px"}
}, null, -1)
const _hoisted_10 = { class: "d-flex ms-3" }
const _hoisted_11 = { style: {"display":"flex","flex-direction":"row","align-items":"center"} }
const _hoisted_12 = { id: "container-logo-header-report" }
const _hoisted_13 = { style: {"margin-left":"32px"} }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-print" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-print" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_DropdownFiscalYear = _resolveComponent("DropdownFiscalYear")!

  return (_openBlock(), _createElementBlock("div", {
    id: "kt_header",
    class: "header",
    "data-kt-sticky": _ctx.isHeaderSticky,
    "data-kt-sticky-name": "header",
    "data-kt-sticky-offset": "{default: '200px', lg: '300px'}"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex align-items-center justify-content-between", {
        'container-fluid': _ctx.headerWidthFluid,
        'container-xxl': !_ctx.headerWidthFluid,
      }]),
      id: "kt_header_container"
    }, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, {
              src: "/media/icons/duotune/abstract/abs015.svg",
              "aria-hidden": "true"
            })
          ])
        ])
      ]),
      (!(_ctx.isAdmin && !_ctx.user_id))
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.translate("DASHBOARD_YEARLY_PERIOD_MESSAGE")) + " - " + _toDisplayString(_ctx.optionYearlyPeriod.current_yearly_period), 1),
              _hoisted_9
            ]),
            _createVNode(_component_DropdownFiscalYear)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            (/^\/(?:(?:admin\/)?report)\/?\d*/.test(String(_ctx.route.path)))
              ? (_openBlock(), _createBlock(_component_inline_svg, {
                  key: 0,
                  src: "/media/vectorial/iii_header_report_logo.svg",
                  style: {"height":"60px"},
                  alt: _ctx.translate('III_PLUS_LOGO'),
                  "aria-label": _ctx.translate('III_PLUS_LOGO'),
                  title: _ctx.translate('III_PLUS_LOGO')
                }, null, 8, ["alt", "aria-label", "title"]))
              : _createCommentVNode("", true),
            (/^\/(?:(?:admin\/)?survey\-plus\/report)\/?\d*/.test(String(_ctx.route.path)))
              ? (_openBlock(), _createBlock(_component_inline_svg, {
                  key: 1,
                  src: "/media/vectorial/inclusion_plus_header_report_logo.svg",
                  alt: _ctx.translate('III_PLUS_LOGO'),
                  "aria-label": _ctx.translate('III_PLUS_LOGO'),
                  title: _ctx.translate('III_PLUS_LOGO')
                }, null, 8, ["alt", "aria-label", "title"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_13, [
            (/^\/(?:(?:admin\/)?report)\/?\d*/.test(String(_ctx.route.path)))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn btn-lg btn-dark-blue",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.printReport && _ctx.printReport(...args)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.translate("REPORT_CURRENT_DETAILS_PAGE_AS_PDF")) + " ", 1),
                  _hoisted_14
                ]))
              : _createCommentVNode("", true),
            (/^\/(?:(?:admin\/)?survey\-plus\/report)\/?\d*/.test(String(_ctx.route.path)))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "btn btn-lg btn-dark-blue",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.printReportPlus && _ctx.printReportPlus(...args)))
                }, [
                  _createTextVNode(_toDisplayString(_ctx.translate("REPORT_CURRENT_DETAILS_PAGE_AS_PDF")) + " ", 1),
                  _hoisted_15
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ], 2)
  ], 8, _hoisted_1))
}